import { IAutoMapper } from "../interfaces";

export const mapRetrievalCallRecordDetailItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "RetrievalCallRecordDetail")
    .forMember("callRecordAudio", o => o.callRecordAudio)
    .forMember("transcriptionText", o => o.transcriptionText);
};
